import { PagedSearch } from '../../../shared/model/paged-search.model';

export class InvoiceSearchParams extends PagedSearch {
  public Keyword: string;
  public OpenInvoicesOnly: boolean;
  public ItemNum: number;
  public InvoiceNumbers: number[];

  public constructor() {
    super();

    this.Keyword = '';
    this.OpenInvoicesOnly = false;
    this.ItemNum = 0;
    this.InvoiceNumbers = [];
  }
}
